//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    donePartially: {
      type: Boolean,
      default: false
    },

    donePreviously: {
      type: Boolean,
      default: false
    },
    donePartiallyPreviously: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },
    disabledReason: {
      type: String,
      default: null
    }
  },

  computed: {
    /*
      внутри - текущее выполнение:
      0 — пусто
      1 — голубой фон
      2 — голубой фон + галочка
      3 — тёмно-синий фон + галочка
    */
    innerState () {
      if (!this.value && !this.donePartially) {
        return 0
      }
      if (!this.value && this.donePartially) {
        return 1
      }
      if (this.value && this.donePartially) {
        return 2
      }
      if (this.value && !this.donePartially) {
        return 3
      }
      return 0
    },
    innerClass () {
      return {
        'inner-0': this.innerState === 0,
        'inner-1': this.innerState === 1,
        'inner-2': this.innerState === 2,
        'inner-3': this.innerState === 3
      }
    },
    /*
      граница - предыдущее выполнение:
      0 — белая
      1 — голубая
      2 — синяя
    */
    borderState () {
      if (this.donePreviously) {
        return 2
      }
      if (this.donePartiallyPreviously) {
        return 1
      }
      return 0
    },
    borderClass () {
      return {
        'border-0': this.borderState === 0,
        'border-1': this.borderState === 1,
        'border-2': this.borderState === 2
      }
    }
  },
  methods: {
    input (event) {
      if (this.disabledReason) {
        this.$q.notify({
          type: 'warning',
          message: this.disabledReason,
          progress: true,
          timeout: 8000
        })
      } else {
        this.$emit('input', event.target.checked)
      }
    }
  }
}

